import { Button, Dialog, SearchInput } from "@tellescope/ui";
import { Filter } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { EditRoleDialogContents } from "./EditRoleDialogContents";
import { RoleCard } from "./RoleCard";
import { RolesFilterDialog } from "./RolesFilterDialog";
import { useRolesSubPage } from "./useRolesSubPage";

export const RolesSubPage = () => {
  const { t } = useTranslation("settings");
  const { searchQuery, setSearchQuery, filters, setFilters, filteredRoles, activeFiltersCount, isLoading } =
    useRolesSubPage();
  const [filterDialogOpen, setFilterDialogOpen] = useState(false);
  const [search, setSearch] = useSearchParams();

  const openRoleId = search.get("roleId") ?? undefined;

  return (
    <div className="flex flex-col flex-1 min-h-0 px-6 pt-4 gap-4 w-full">
      <div className="flex items-center gap-2 w-full">
        <SearchInput
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder={t("Search roles...")}
          className="grow"
          wrapperClassName="grow"
        />
        <Button
          variant="outline"
          className="relative h-9 w-9 p-0"
          onClick={() => setFilterDialogOpen(true)}
          hoverLabel={t("Filter roles")}
          data-trackingid="roles-subpage-filter"
        >
          <Filter strokeWidth={1.8} />
          {!!activeFiltersCount && <span className="absolute top-1 right-1 h-2 w-2 rounded-full bg-primary" />}
        </Button>
      </div>

      {isLoading ? (
        <p className="text-muted-foreground">{t("Loading roles...")}</p>
      ) : filteredRoles.length === 0 ? (
        <p className="text-muted-foreground">{t("No roles found.")}</p>
      ) : (
        <div className="grid grid-cols-1 gap-4 overflow-y-auto pb-4 sm:grid-cols-2 lg:grid-cols-3">
          {filteredRoles.map((role) => (
            <RoleCard
              key={role.id}
              role={role}
              onSelect={(roleId) =>
                setSearch((prev) => {
                  prev.set("roleId", roleId);
                  return prev;
                })
              }
            />
          ))}
        </div>
      )}

      <RolesFilterDialog
        open={filterDialogOpen}
        onOpenChange={setFilterDialogOpen}
        filters={filters}
        onApply={(next) => {
          setFilters(next);
          setFilterDialogOpen(false);
        }}
      />

      <Dialog
        open={!!openRoleId}
        onOpenChange={(open) => {
          if (!open) {
            setSearch((prev) => {
              prev.delete("roleId");
              return prev;
            });
          }
        }}
      >
        <EditRoleDialogContents
          roleId={openRoleId}
          onClose={() =>
            setSearch((prev) => {
              prev.delete("roleId");
              return prev;
            })
          }
        />
      </Dialog>
    </div>
  );
};
